export function toPublishPage(data) {
  const videoUrl =  encodeURIComponent(data.videoUrl); // 视频地址
  const coverUrl =  encodeURIComponent(data.coverUrl); // 视频封面地址
  const queryFromMigu = localStorage.getItem('queryFromMigu') || ''; // 其他参数使用migu传递的
  const url = `https://y.migu.cn/app/v5/p/publish-mid/index.html?videoUrl=${videoUrl}&videoCover=${coverUrl}&${queryFromMigu}`;
  window.location.href = url;
}